import { gql } from '@apollo/client'

const GET_GOOGLE_DRIVE_TOKEN = gql`
  query GET_GOOGLE_DRIVE_TOKEN {
    getGoogleDriveToken {
      token
      expiry
    }
  }
`

export default GET_GOOGLE_DRIVE_TOKEN
